//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../index";

// state
const agentsListSelector = (state: RootState) => state.admin.cashier.list;
const agentsListDataSelector = (state: RootState) => state.admin.cashier.list.data;
const agentsListErrorSelector = (state: RootState) => state.admin.cashier.list.error;
const agentsListFetchingSelector = (state: RootState) => state.admin.cashier.list.isFetching;

//selectors
export const selectList = createSelector(agentsListSelector, (list) => list);
export const selectListData = createSelector(agentsListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }
      if (item.name === 'isPublic') {
        return { ...item, type: 'badge' };
      }
      if (item.name === 'wallets') {
        return { ...item, type: 'cashierWallets' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: !!item.country ? [
          {
            id: item.country,
            label: item.country,
          }
        ] : [],
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectListDataColumnsSort = createSelector(agentsListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectListError = createSelector(agentsListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(agentsListFetchingSelector, (isFetching) => isFetching);


const agentsFullListSelector = (state: RootState) => state.admin.cashier.fullList;
const agentsFullListDataSelector = (state: RootState) => state.admin.cashier.fullList.data;
const agentsFullListErrorSelector = (state: RootState) => state.admin.cashier.fullList.error;
const agentsFullListFetchingSelector = (state: RootState) => state.admin.cashier.fullList.isFetching;

//selectors
export const selectFullList = createSelector(agentsFullListSelector, (list) => list);
export const selectFullListData = createSelector(agentsFullListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        countries: item.countries.map((geo: string) => {
          return {
            id: geo,
            label: geo,
          }
        })
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectFullListDataColumnsSort = createSelector(agentsFullListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectFullListError = createSelector(agentsFullListErrorSelector, (error) => error);
export const selectFullListIsFetching = createSelector(agentsFullListFetchingSelector, (isFetching) => isFetching);


//Brands List
const agentsBrandsListDataSelector = (state: RootState) => state.admin.cashier.brandsList.data;
const agentsBrandsListErrorSelector = (state: RootState) => state.admin.cashier.brandsList.error;
const agentsBrandsListFetchingSelector = (state: RootState) => state.admin.cashier.brandsList.isFetching;

export const selectAgentsBrandsListData = createSelector(agentsBrandsListDataSelector, (data) => {
  if (!!data && !!data.hasOwnProperty('list')) {
    // @ts-ignore
    return data?.list;
  } else {
    return data;
  }
});
export const selectAgentsBrandsListError = createSelector(agentsBrandsListErrorSelector, (error) => error);
export const selectAgentsBrandsListIsFetching = createSelector(agentsBrandsListFetchingSelector, (isFetching) => isFetching);


//Wallets List
const agentsWalletsDataSelector = (state: RootState) => state.admin.cashier.wallets.data;
const agentsWalletsErrorSelector = (state: RootState) => state.admin.cashier.wallets.error;
const agentsWalletsFetchingSelector = (state: RootState) => state.admin.cashier.wallets.isFetching;

export const selectWalletsData = createSelector(agentsWalletsDataSelector, (data) => data);
export const selectWalletsError = createSelector(agentsWalletsErrorSelector, (error) => error);
export const selectWalletsIsFetching = createSelector(agentsWalletsFetchingSelector, (isFetching) => isFetching);

//Wallets List
const agentsCreateWalletsDataSelector = (state: RootState) => state.admin.cashier.createWallets.data;
const agentsCreateWalletsErrorSelector = (state: RootState) => state.admin.cashier.createWallets.error;
const agentsCreateWalletsFetchingSelector = (state: RootState) => state.admin.cashier.createWallets.isFetching;

export const selectCreateWalletsData = createSelector(agentsCreateWalletsDataSelector, (data) => data);
export const selectCreateWalletsError = createSelector(agentsCreateWalletsErrorSelector, (error) => error);
export const selectCreateWalletsIsFetching = createSelector(agentsCreateWalletsFetchingSelector, (isFetching) => isFetching);


//Agent Options
const agentsDescendantAgentsDataSelector = (state: RootState) => state.admin.cashier.descendantAgents.data;
const agentsDescendantAgentsErrorSelector = (state: RootState) => state.admin.cashier.descendantAgents.error;
const agentsDescendantAgentsFetchingSelector = (state: RootState) => state.admin.cashier.descendantAgents.isFetching;

export const selectDescendantAgentsData = createSelector(agentsDescendantAgentsDataSelector, (data) => data);
export const selectDescendantAgentsError = createSelector(agentsDescendantAgentsErrorSelector, (error) => error);
export const selectDescendantAgentsIsFetching = createSelector(agentsDescendantAgentsFetchingSelector, (isFetching) => isFetching);

//Full Agent Options
const agentsFullAgentsOptionsDataSelector = (state: RootState) => state.admin.cashier.fullAgentsOptions.data;
const agentsFullAgentsOptionsErrorSelector = (state: RootState) => state.admin.cashier.fullAgentsOptions.error;
const agentsFullAgentsOptionsFetchingSelector = (state: RootState) => state.admin.cashier.fullAgentsOptions.isFetching;

export const selectFullAgentsOptionsData = createSelector(agentsFullAgentsOptionsDataSelector, (data) => data);
export const selectFullAgentsOptionsError = createSelector(agentsFullAgentsOptionsErrorSelector, (error) => error);
export const selectFullAgentsOptionsIsFetching = createSelector(agentsFullAgentsOptionsFetchingSelector, (isFetching) => isFetching);


//Full Tr Agent Options
const agentsFullTrAgentsOptionsDataSelector = (state: RootState) => state.admin.cashier.fullTrAgentsOptions.data;
const agentsFullTrAgentsOptionsErrorSelector = (state: RootState) => state.admin.cashier.fullTrAgentsOptions.error;
const agentsFullTrAgentsOptionsFetchingSelector = (state: RootState) => state.admin.cashier.fullTrAgentsOptions.isFetching;

export const selectFullTrAgentsOptionsData = createSelector(agentsFullTrAgentsOptionsDataSelector, (data) => data);
export const selectFullTrAgentsOptionsError = createSelector(agentsFullTrAgentsOptionsErrorSelector, (error) => error);
export const selectFullTrAgentsOptionsIsFetching = createSelector(agentsFullTrAgentsOptionsFetchingSelector, (isFetching) => isFetching);


//Agent Roles
const agentsRolesDataSelector = (state: RootState) => state.admin.cashier.agentRoles.data;
const agentsRolesErrorSelector = (state: RootState) => state.admin.cashier.agentRoles.error;
const agentsRolesFetchingSelector = (state: RootState) => state.admin.cashier.agentRoles.isFetching;

export const selectAgentsRolesData = createSelector(agentsRolesDataSelector, (data) => data);
export const selectAgentsRolesError = createSelector(agentsRolesErrorSelector, (error) => error);
export const selectAgentsRolesIsFetching = createSelector(agentsRolesFetchingSelector, (isFetching) => isFetching);

//WalletIdentities
const agentsWalletIdentitiesDataSelector = (state: RootState) => state.admin.cashier.walletIdentities.data;
const agentsWalletIdentitiesErrorSelector = (state: RootState) => state.admin.cashier.walletIdentities.error;
const agentsWalletIdentitiesFetchingSelector = (state: RootState) => state.admin.cashier.walletIdentities.isFetching;

export const selectWalletIdentitiesData = createSelector(agentsWalletIdentitiesDataSelector, (data) => data);
export const selectWalletIdentitiesError = createSelector(agentsWalletIdentitiesErrorSelector, (error) => error);
export const selectWalletIdentitiesIsFetching = createSelector(agentsWalletIdentitiesFetchingSelector, (isFetching) => isFetching);

//CreateAgent
const agentsCreateAgentDataSelector = (state: RootState) => state.admin.cashier.createAgent.data;
const agentsCreateAgentErrorSelector = (state: RootState) => state.admin.cashier.createAgent.error;
const agentsCreateAgentFetchingSelector = (state: RootState) => state.admin.cashier.createAgent.isFetching;

export const selectCreateAgentData = createSelector(agentsCreateAgentDataSelector, (data) => data);
export const selectCreateAgentError = createSelector(agentsCreateAgentErrorSelector, (error) => error);
export const selectCreateAgentIsFetching = createSelector(agentsCreateAgentFetchingSelector, (isFetching) => isFetching);

//DetailsListRow
const agentsDetailsAgentDataSelector = (state: RootState) => state.admin.cashier.details.data;
const agentsDetailsAgentErrorSelector = (state: RootState) => state.admin.cashier.details.error;
const agentsDetailsAgentFetchingSelector = (state: RootState) => state.admin.cashier.details.isFetching;

export const selectDetailsListAgentData = createSelector(agentsDetailsAgentDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }
      if (item.name === 'username') {
        return { ...item, type: 'shortUsername' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: !!item.country ? [
          {
            id: item.country,
            label: item.country,
          }
        ] : [],
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectDetailsListAgentError = createSelector(agentsDetailsAgentErrorSelector, (error) => error);
export const selectDetailsListAgentIsFetching = createSelector(agentsDetailsAgentFetchingSelector, (isFetching) => isFetching);

//FullDetailsListRow
const agentsFullDetailsAgentDataSelector = (state: RootState) => state.admin.cashier.fullDetails.data;
const agentsFullDetailsAgentErrorSelector = (state: RootState) => state.admin.cashier.fullDetails.error;
const agentsFullDetailsAgentFetchingSelector = (state: RootState) => state.admin.cashier.fullDetails.isFetching;

export const selectFullDetailsListAgentData = createSelector(agentsFullDetailsAgentDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }
      if (item.name === 'username') {
        return { ...item, type: 'shortUsername' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        countries: item.countries.map((geo: string) => {
          return {
            id: geo,
            label: geo,
          }
        })
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectFullDetailsListAgentError = createSelector(agentsFullDetailsAgentErrorSelector, (error) => error);
export const selectFullDetailsListAgentIsFetching = createSelector(agentsFullDetailsAgentFetchingSelector, (isFetching) => isFetching);

//Enable Wallet
const agentsEnableWalletDataSelector = (state: RootState) => state.admin.cashier.enableWallet.data;
const agentsEnableWalletErrorSelector = (state: RootState) => state.admin.cashier.enableWallet.error;
const agentsEnableWalletFetchingSelector = (state: RootState) => state.admin.cashier.enableWallet.isFetching;

export const selectEnableWalletData = createSelector(agentsEnableWalletDataSelector, (data) => data);
export const selectEnableWalletError = createSelector(agentsEnableWalletErrorSelector, (error) => error);
export const selectEnableWalletIsFetching = createSelector(agentsEnableWalletFetchingSelector, (isFetching) => isFetching);


//Enable Wallet
const agentsDisableWalletDataSelector = (state: RootState) => state.admin.cashier.disableWallet.data;
const agentsDisableWalletErrorSelector = (state: RootState) => state.admin.cashier.disableWallet.error;
const agentsDisableWalletFetchingSelector = (state: RootState) => state.admin.cashier.disableWallet.isFetching;

export const selectDisableWalletData = createSelector(agentsDisableWalletDataSelector, (data) => data);
export const selectDisableWalletError = createSelector(agentsDisableWalletErrorSelector, (error) => error);
export const selectDisableWalletIsFetching = createSelector(agentsDisableWalletFetchingSelector, (isFetching) => isFetching);

//Add Wallet
const agentsAddWalletDataSelector = (state: RootState) => state.admin.cashier.addWallet.data;
const agentsAddWalletErrorSelector = (state: RootState) => state.admin.cashier.addWallet.error;
const agentsAddWalletFetchingSelector = (state: RootState) => state.admin.cashier.addWallet.isFetching;

export const selectAddWalletData = createSelector(agentsAddWalletDataSelector, (data) => data);
export const selectAddWalletError = createSelector(agentsAddWalletErrorSelector, (error) => error);
export const selectAddWalletIsFetching = createSelector(agentsAddWalletFetchingSelector, (isFetching) => isFetching);

//Agent Balance
const agentsAgentBalanceDataSelector = (state: RootState) => state.admin.cashier.agentBalance.data;
const agentsAgentBalanceErrorSelector = (state: RootState) => state.admin.cashier.agentBalance.error;
const agentsAgentBalanceFetchingSelector = (state: RootState) => state.admin.cashier.agentBalance.isFetching;

export const selectAgentBalanceData = createSelector(agentsAgentBalanceDataSelector, (data) => data);
export const selectAgentBalanceError = createSelector(agentsAgentBalanceErrorSelector, (error) => error);
export const selectAgentBalanceIsFetching = createSelector(agentsAgentBalanceFetchingSelector, (isFetching) => isFetching);

//Admin Balance
const agentsAdminBalanceDataSelector = (state: RootState) => state.admin.cashier.adminBalance.data;
const agentsAdminBalanceErrorSelector = (state: RootState) => state.admin.cashier.adminBalance.error;
const agentsAdminBalanceFetchingSelector = (state: RootState) => state.admin.cashier.adminBalance.isFetching;

export const selectAdminBalanceData = createSelector(agentsAdminBalanceDataSelector, (data) => data);
export const selectAdminBalanceError = createSelector(agentsAdminBalanceErrorSelector, (error) => error);
export const selectAdminBalanceIsFetching = createSelector(agentsAdminBalanceFetchingSelector, (isFetching) => isFetching);

//PlayerList
const agentsPlayerListDataSelector = (state: RootState) => state.admin.cashier.playerList.data;
const agentsPlayerListErrorSelector = (state: RootState) => state.admin.cashier.playerList.error;
const agentsPlayerListFetchingSelector = (state: RootState) => state.admin.cashier.playerList.isFetching;

export const selectPlayerListData = createSelector(agentsPlayerListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectPlayerListDataColumnsSort = createSelector(agentsPlayerListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectPlayerListError = createSelector(agentsPlayerListErrorSelector, (error) => error);
export const selectPlayerListIsFetching = createSelector(agentsPlayerListFetchingSelector, (isFetching) => isFetching);

//PlayerList
const agentsFullPlayerListDataSelector = (state: RootState) => state.admin.cashier.fullPlayerList.data;
const agentsFullPlayerListErrorSelector = (state: RootState) => state.admin.cashier.fullPlayerList.error;
const agentsFullPlayerListFetchingSelector = (state: RootState) => state.admin.cashier.fullPlayerList.isFetching;

export const selectFullPlayerListData = createSelector(agentsFullPlayerListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectFullPlayerListDataColumnsSort = createSelector(agentsFullPlayerListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectFullPlayerListError = createSelector(agentsFullPlayerListErrorSelector, (error) => error);
export const selectFullPlayerListIsFetching = createSelector(agentsFullPlayerListFetchingSelector, (isFetching) => isFetching);

//Player Balance
const agentsPlayerBalanceDataSelector = (state: RootState) => state.admin.cashier.playerBalance.data;
const agentsPlayerBalanceErrorSelector = (state: RootState) => state.admin.cashier.playerBalance.error;
const agentsPlayerBalanceFetchingSelector = (state: RootState) => state.admin.cashier.playerBalance.isFetching;

export const selectPlayerBalanceData = createSelector(agentsPlayerBalanceDataSelector, (data) => data);
export const selectPlayerBalanceError = createSelector(agentsPlayerBalanceErrorSelector, (error) => error);
export const selectPlayerBalanceIsFetching = createSelector(agentsPlayerBalanceFetchingSelector, (isFetching) => isFetching);

//PlayerList Details
const agentsPlayerListDetailsDataSelector = (state: RootState) => state.admin.cashier.playerDetails.data;
const agentsPlayerListDetailsErrorSelector = (state: RootState) => state.admin.cashier.playerDetails.error;
const agentsPlayerListDetailsFetchingSelector = (state: RootState) => state.admin.cashier.playerDetails.isFetching;

export const selectPlayerListDetailsData = createSelector(agentsPlayerListDetailsDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectPlayerDetailsListError = createSelector(agentsPlayerListDetailsErrorSelector, (error) => error);
export const selectPlayerListDetailsIsFetching = createSelector(agentsPlayerListDetailsFetchingSelector, (isFetching) => isFetching);

//FullPlayerList Details
const agentsFullPlayerListDetailsDataSelector = (state: RootState) => state.admin.cashier.fullPlayerDetails.data;
const agentsFullPlayerListDetailsErrorSelector = (state: RootState) => state.admin.cashier.fullPlayerDetails.error;
const agentsFullPlayerListDetailsFetchingSelector = (state: RootState) => state.admin.cashier.fullPlayerDetails.isFetching;

export const selectFullPlayerListDetailsData = createSelector(agentsFullPlayerListDetailsDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectFullPlayerDetailsListError = createSelector(agentsFullPlayerListDetailsErrorSelector, (error) => error);
export const selectFullPlayerListDetailsIsFetching = createSelector(agentsFullPlayerListDetailsFetchingSelector, (isFetching) => isFetching);

//transferToAgent
const agentsTransferToAgentDataSelector = (state: RootState) => state.admin.cashier.transferToAgent.data;
const agentsTransferToAgentErrorSelector = (state: RootState) => state.admin.cashier.transferToAgent.error;
const agentsTransferToAgentFetchingSelector = (state: RootState) => state.admin.cashier.transferToAgent.isFetching;

export const selectTransferToAgentData = createSelector(agentsTransferToAgentDataSelector, (data) => data);
export const selectTransferToAgentError = createSelector(agentsTransferToAgentErrorSelector, (error) => error);
export const selectTransferToAgentIsFetching = createSelector(agentsTransferToAgentFetchingSelector, (isFetching) => isFetching);

//transferAllToAgent
const agentsTransferAllToAgentDataSelector = (state: RootState) => state.admin.cashier.transferAllToAgent.data;
const agentsTransferAllToAgentErrorSelector = (state: RootState) => state.admin.cashier.transferAllToAgent.error;
const agentsTransferAllToAgentFetchingSelector = (state: RootState) => state.admin.cashier.transferAllToAgent.isFetching;

export const selectTransferAllToAgentData = createSelector(agentsTransferAllToAgentDataSelector, (data) => data);
export const selectTransferAllToAgentError = createSelector(agentsTransferAllToAgentErrorSelector, (error) => error);
export const selectTransferAllToAgentIsFetching = createSelector(agentsTransferAllToAgentFetchingSelector, (isFetching) => isFetching);

//Players Options
const agentsPlayersOptionsDataSelector = (state: RootState) => state.admin.cashier.playersOptions.data;
const agentsPlayersOptionsErrorSelector = (state: RootState) => state.admin.cashier.playersOptions.error;
const agentsPlayersOptionsFetchingSelector = (state: RootState) => state.admin.cashier.playersOptions.isFetching;

export const selectPlayersOptionsData = createSelector(agentsPlayersOptionsDataSelector, (data) => data);
export const selectPlayersOptionsError = createSelector(agentsPlayersOptionsErrorSelector, (error) => error);
export const selectPlayersOptionsIsFetching = createSelector(agentsPlayersOptionsFetchingSelector, (isFetching) => isFetching);

//Players WalletIdentities
const agentsPlayerWalletIdentitiesDataSelector = (state: RootState) => state.admin.cashier.playerWalletIdentities.data;
const agentsPlayerWalletIdentitiesErrorSelector = (state: RootState) => state.admin.cashier.playerWalletIdentities.error;
const agentsPlayerWalletIdentitiesFetchingSelector = (state: RootState) => state.admin.cashier.playerWalletIdentities.isFetching;

export const selectPlayerWalletIdentitiesData = createSelector(agentsPlayerWalletIdentitiesDataSelector, (data) => data);
export const selectPlayerWalletIdentitiesError = createSelector(agentsPlayerWalletIdentitiesErrorSelector, (error) => error);
export const selectPlayerWalletIdentitiesIsFetching = createSelector(agentsPlayerWalletIdentitiesFetchingSelector, (isFetching) => isFetching);

//transferToPlayer
const agentsTransferToPlayerDataSelector = (state: RootState) => state.admin.cashier.transferToPlayer.data;
const agentsTransferToPlayerErrorSelector = (state: RootState) => state.admin.cashier.transferToPlayer.error;
const agentsTransferToPlayerFetchingSelector = (state: RootState) => state.admin.cashier.transferToPlayer.isFetching;

export const selectTransferToPlayerData = createSelector(agentsTransferToPlayerDataSelector, (data) => data);
export const selectTransferToPlayerError = createSelector(agentsTransferToPlayerErrorSelector, (error) => error);
export const selectTransferToPlayerIsFetching = createSelector(agentsTransferToPlayerFetchingSelector, (isFetching) => isFetching);

//AgentProfile
const agentsAgentProfileDataSelector = (state: RootState) => state.admin.cashier.agentProfile.data;
const agentsAgentProfileErrorSelector = (state: RootState) => state.admin.cashier.agentProfile.error;
const agentsAgentProfileFetchingSelector = (state: RootState) => state.admin.cashier.agentProfile.isFetching;

export const selectAgentProfileData = createSelector(agentsAgentProfileDataSelector, (data) => data);
export const selectAgentProfileError = createSelector(agentsAgentProfileErrorSelector, (error) => error);
export const selectAgentProfileIsFetching = createSelector(agentsAgentProfileFetchingSelector, (isFetching) => isFetching);


//UpdateAgentProfile
const agentsUpdateAgentProfileDataSelector = (state: RootState) => state.admin.cashier.updateAgentProfile.data;
const agentsUpdateAgentProfileErrorSelector = (state: RootState) => state.admin.cashier.updateAgentProfile.error;
const agentsUpdateAgentProfileFetchingSelector = (state: RootState) => state.admin.cashier.updateAgentProfile.isFetching;

export const selectUpdateAgentProfileData = createSelector(agentsUpdateAgentProfileDataSelector, (data) => data);
export const selectUpdateAgentProfileError = createSelector(agentsUpdateAgentProfileErrorSelector, (error) => error);
export const selectUpdateAgentProfileIsFetching = createSelector(agentsUpdateAgentProfileFetchingSelector, (isFetching) => isFetching);

//PlayerProfile
const agentsPlayerProfileDataSelector = (state: RootState) => state.admin.cashier.playerProfile.data;
const agentsPlayerProfileErrorSelector = (state: RootState) => state.admin.cashier.playerProfile.error;
const agentsPlayerProfileFetchingSelector = (state: RootState) => state.admin.cashier.playerProfile.isFetching;

export const selectPlayerProfileData = createSelector(agentsPlayerProfileDataSelector, (data) => data);
export const selectPlayerProfileError = createSelector(agentsPlayerProfileErrorSelector, (error) => error);
export const selectPlayerProfileIsFetching = createSelector(agentsPlayerProfileFetchingSelector, (isFetching) => isFetching);

//UpdateAgentRole
const agentsUpdateAgentRoleDataSelector = (state: RootState) => state.admin.cashier.updateAgentRole.data;
const agentsUpdateAgentRoleErrorSelector = (state: RootState) => state.admin.cashier.updateAgentRole.error;
const agentsUpdateAgentRoleFetchingSelector = (state: RootState) => state.admin.cashier.updateAgentRole.isFetching;

export const selectUpdateAgentRoleData = createSelector(agentsUpdateAgentRoleDataSelector, (data) => data);
export const selectUpdateAgentRoleError = createSelector(agentsUpdateAgentRoleErrorSelector, (error) => error);
export const selectUpdateAgentRoleIsFetching = createSelector(agentsUpdateAgentRoleFetchingSelector, (isFetching) => isFetching);


//Filter Roles
const filterRolesDataSelector = (state: RootState) => state.admin.cashier.filterRoles.data;
const filterRolesErrorSelector = (state: RootState) => state.admin.cashier.filterRoles.error;
const filterRolesFetchingSelector = (state: RootState) => state.admin.cashier.filterRoles.isFetching;

export const selectFilterRolesData = createSelector(filterRolesDataSelector, (data) => data);
export const selectFilterRolesError = createSelector(filterRolesErrorSelector, (error) => error);
export const selectFilterRolesIsFetching = createSelector(filterRolesFetchingSelector, (isFetching) => isFetching);

//Filter Roles All
const filterRolesAllDataSelector = (state: RootState) => state.admin.cashier.filterRolesAll.data;
const filterRolesAllErrorSelector = (state: RootState) => state.admin.cashier.filterRolesAll.error;
const filterRolesAllFetchingSelector = (state: RootState) => state.admin.cashier.filterRolesAll.isFetching;

export const selectFilterRolesAllData = createSelector(filterRolesAllDataSelector, (data) => data);
export const selectFilterRolesAllError = createSelector(filterRolesAllErrorSelector, (error) => error);
export const selectFilterRolesAllIsFetching = createSelector(filterRolesAllFetchingSelector, (isFetching) => isFetching);

//Block agent
const toggleBlockAgentDataSelector = (state: RootState) => state.admin.cashier.blockAgent.data;
const toggleBlockAgentErrorSelector = (state: RootState) => state.admin.cashier.blockAgent.error;
const toggleBlockAgentFetchingSelector = (state: RootState) => state.admin.cashier.blockAgent.isFetching;

export const selectToggleBlockAgentData = createSelector(toggleBlockAgentDataSelector, (data) => data);
export const selectToggleBlockAgentError = createSelector(toggleBlockAgentErrorSelector, (error) => error);
export const selectToggleBlockAgentIsFetching = createSelector(toggleBlockAgentFetchingSelector, (isFetching) => isFetching);

//agentNewPassword
const agentsNewPasswordDataSelector = (state: RootState) => state.admin.cashier.agentNewPassword.data;
const agentsNewPasswordErrorSelector = (state: RootState) => state.admin.cashier.agentNewPassword.error;
const agentsNewPasswordFetchingSelector = (state: RootState) => state.admin.cashier.agentNewPassword.isFetching;

export const selectAgentNewPasswordData = createSelector(agentsNewPasswordDataSelector, (data) => data);
export const selectAgentNewPasswordError = createSelector(agentsNewPasswordErrorSelector, (error) => error);
export const selectAgentNewPasswordIsFetching = createSelector(agentsNewPasswordFetchingSelector, (isFetching) => isFetching);

//BetList filters
const betListFiltersDataSelector = (state: RootState) => state.admin.cashier.betListFilters.data;
const betListFiltersErrorSelector = (state: RootState) => state.admin.cashier.betListFilters.error;
const betListFiltersFetchingSelector = (state: RootState) => state.admin.cashier.betListFilters.isFetching;

export const selectBetListFiltersData = createSelector(betListFiltersDataSelector, (data) => data);
export const selectBetListFiltersError = createSelector(betListFiltersErrorSelector, (error) => error);
export const selectBetListFiltersIsFetching = createSelector(betListFiltersFetchingSelector, (isFetching) => isFetching);

//Casino BetList filters
const casinoBetListFiltersDataSelector = (state: RootState) => state.admin.cashier.casinoBetListFilters.data;
const casinoBetListFiltersErrorSelector = (state: RootState) => state.admin.cashier.casinoBetListFilters.error;
const casinoBetListFiltersFetchingSelector = (state: RootState) => state.admin.cashier.casinoBetListFilters.isFetching;

export const selectCasinoBetListFiltersData = createSelector(casinoBetListFiltersDataSelector, (data) => data);
export const selectCasinoBetListFiltersError = createSelector(casinoBetListFiltersErrorSelector, (error) => error);
export const selectCasinoBetListFiltersIsFetching = createSelector(casinoBetListFiltersFetchingSelector, (isFetching) => isFetching);

//Block player
const toggleBlockPlayerDataSelector = (state: RootState) => state.admin.cashier.blockPlayer.data;
const toggleBlockPlayerErrorSelector = (state: RootState) => state.admin.cashier.blockPlayer.error;
const toggleBlockPlayerFetchingSelector = (state: RootState) => state.admin.cashier.blockPlayer.isFetching;

export const selectToggleBlockPlayerData = createSelector(toggleBlockPlayerDataSelector, (data) => data);
export const selectToggleBlockPlayerError = createSelector(toggleBlockPlayerErrorSelector, (error) => error);
export const selectToggleBlockPlayerIsFetching = createSelector(toggleBlockPlayerFetchingSelector, (isFetching) => isFetching);

//Player status
const playerStatusDataSelector = (state: RootState) => state.admin.cashier.playerStatus.data;
const playerStatusErrorSelector = (state: RootState) => state.admin.cashier.playerStatus.error;
const playerStatusFetchingSelector = (state: RootState) => state.admin.cashier.playerStatus.isFetching;

export const selectPlayerStatusData = createSelector(playerStatusDataSelector, (data) => data);
export const selectPlayerStatusError = createSelector(playerStatusErrorSelector, (error) => error);
export const selectPlayerStatusIsFetching = createSelector(playerStatusFetchingSelector, (isFetching) => isFetching);

//playerewPassword
const playerNewPasswordDataSelector = (state: RootState) => state.admin.cashier.playerNewPassword.data;
const playerNewPasswordErrorSelector = (state: RootState) => state.admin.cashier.playerNewPassword.error;
const playerNewPasswordFetchingSelector = (state: RootState) => state.admin.cashier.playerNewPassword.isFetching;

export const selectPlayerNewPasswordData = createSelector(playerNewPasswordDataSelector, (data) => data);
export const selectPlayerNewPasswordError = createSelector(playerNewPasswordErrorSelector, (error) => error);
export const selectPlayerNewPasswordIsFetching = createSelector(playerNewPasswordFetchingSelector, (isFetching) => isFetching);

//Create Player
const agentsCreatePlayerDataSelector = (state: RootState) => state.admin.cashier.createPlayer.data;
const agentsCreatePlayerErrorSelector = (state: RootState) => state.admin.cashier.createPlayer.error;
const agentsCreatePlayerFetchingSelector = (state: RootState) => state.admin.cashier.createPlayer.isFetching;

export const selectCreatePlayerData = createSelector(agentsCreatePlayerDataSelector, (data) => data);
export const selectCreatePlayerError = createSelector(agentsCreatePlayerErrorSelector, (error) => error);
export const selectCreatePlayerIsFetching = createSelector(agentsCreatePlayerFetchingSelector, (isFetching) => isFetching);


//WalletIdentities
const cashierWalletIdentitiesDataSelector = (state: RootState) => state.admin.cashier.cashierWalletIdentities.data;
const cashierWalletIdentitiesErrorSelector = (state: RootState) => state.admin.cashier.cashierWalletIdentities.error;
const cashierWalletIdentitiesFetchingSelector = (state: RootState) => state.admin.cashier.cashierWalletIdentities.isFetching;

export const selectCashierWalletIdentitiesData = createSelector(cashierWalletIdentitiesDataSelector, (data) => data);
export const selectCashierWalletIdentitiesError = createSelector(cashierWalletIdentitiesErrorSelector, (error) => error);
export const selectCashierWalletIdentitiesIsFetching = createSelector(cashierWalletIdentitiesFetchingSelector, (isFetching) => isFetching);
